// Main changes in ShowHide.tsx

import { useState, useEffect, Dispatch } from 'react';
import { connect } from 'react-redux';
import '../ChartOptions.css';
import {
  MeasureValue,
  showHideFilter,
  SortChartData,
  setShowHideNumberInputValue,
  setShowHideOperatorValue,
  setShowNumAction,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { FormControl, MenuItem, Select, Typography, Tooltip } from '@mui/material';
import '../ShowHide/ShowHide.css';
import { PatternCollectionType } from '../../ChartFieldFilter/UserFilterCardInterface';
import { editChartPropItem } from '../../../redux/ChartPoperties/ChartPropertiesActions';
import { useDispatch } from 'react-redux';
import { filterShowHideData } from './filterShowHideData';
import Numb from './ShowHideMeasureSection';
import ChartsInfo from '../../ChartAxes/ChartsInfo2';
import { checkMinRequiredCards } from '../../ChartAxes/chartDataFunctions/checkMinRequiredCards';
import { getNameFromUid } from '../../CommonFunctions/CommonFunctions';
import { OrientationRadioGroup } from '../Legend/LegendComponents/OrientationRadioGroup';

export const equalPatternCollections: PatternCollectionType[] = [
  { key: 'greaterThan', value: '> Greater than' },
  { key: 'lessThan', value: '< Less than' },
  { key: 'greaterThanOrEqualTo', value: '>= Greater than or Equal to' },
  { key: 'lessThanOrEqualTo', value: '<= Less than or Equal to' },
  { key: 'equalTo', value: '= Equal to' },
];
interface Props {
  chartProp: any;
  chartControls: any;
  tabTileProps: any;
  SortChartData: (propKey: string, chartData: string | any) => void;
  showHideFilter: (propKey: string, isShow: boolean) => void;
  MeasureValue: (propKey: string, chartData: string | any) => void;
}

const ShowHide = ({
  chartProp,
  chartControls,
  tabTileProps,
  SortChartData,
  MeasureValue,
  showHideFilter,
  iconColor,
  backgroundColor,
}: Props & { iconColor?: string; backgroundColor?: string }) => {
  const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const [ascDescNotify, setAscDescNotify] = useState<string>('');
  const [selectedMembers, setSelectedMembers] = useState<string[]>([]);
  const [funcnum, setFuncnum] = useState<string>(
    chartControls.properties[propKey].showHide?.funcNum || 'Numb',
  );

  // Fix 1: Better data initialization and management
  const data =
    chartControls.properties[propKey].chartData.length > 0
      ? chartControls.properties[propKey].chartData
      : [];

  // Fix 2: Proper state initialization with useRef to avoid stale data
  const [chartData, setChartData] = useState<any[]>([]);
  const [descendingChartData, setDescendingChartData] = useState<any[]>(data);
  const [serverChartData, setServerChartData] = useState<any[]>(
    chartControls.properties[propKey].serverData,
  );

  const [storeind, setStoreind] = useState(
    chartControls.properties[propKey].showHide?.dataType || '',
  );
  const [shownum, setShownum] = useState(
    chartControls.properties[propKey].showHide?.showNum || true,
  );
  const [hidenum, setHidenum] = useState(
    !chartControls.properties[propKey].showHide?.showNum || false,
  );
  const [value, setValue] = useState<string | number>(
    chartControls.properties[propKey].showHide?.numberInput,
  );

  const [h, setH] = useState<string>(
    chartControls.properties[propKey].showHide?.operator || equalPatternCollections[0].value,
  );

  const [selectedValue, setSelectedValue] = useState(
    chartControls.properties[propKey].showHide?.operator || equalPatternCollections[0].value,
  );

  const dispatch = useDispatch();

  const currentChartType = chartProp.properties[propKey].chartType;
  const prevChartType = chartProp.properties[propKey].oldChartName;
  const chartsAreSwitched =
    prevChartType && prevChartType !== '' && prevChartType !== currentChartType ? true : false;

  const fullString = getNameFromUid(
    chartProp.properties[propKey].chartAxes,
    chartControls?.properties[propKey]?.showHide?.measureName,
  );
  const valueAfterOf = fullString?.split('of')[1]?.trim();
  const isShow = chartControls.properties[propKey].showHide?.isShow;

  // Fix 3: Using useEffect with proper dependencies to update local data when redux data changes
  useEffect(() => {
    if (data.length > 0) {
      const newData = JSON.parse(JSON.stringify(data));
      setChartData(newData);
      setDescendingChartData(newData);
    }
  }, [data, propKey]);

  useEffect(() => {
    setServerChartData(chartControls.properties[propKey].serverData);
  });

  //reset showHide input value and operator value

  const resetShowHideValuesToDefault = () => {
    const DEFAULT_FILTER_VALUE = '';
    const DEFAULT_OPERATOR_VALUE = '> Greater than';

    setValue(DEFAULT_FILTER_VALUE);
    dispatch(
      setShowHideNumberInputValue(
        propKey,
        DEFAULT_FILTER_VALUE,
        chartControls.properties[propKey].showHide?.dataType,
      ),
    );

    setH(DEFAULT_OPERATOR_VALUE);
    setSelectedValue(DEFAULT_OPERATOR_VALUE);
    dispatch(setShowHideOperatorValue(propKey, DEFAULT_OPERATOR_VALUE));

    if (h === DEFAULT_OPERATOR_VALUE && serverChartData && serverChartData.length > 0) {
      filterShowHideData(
        DEFAULT_OPERATOR_VALUE,
        dispatch,
        serverChartData,
        propKey,
        DEFAULT_FILTER_VALUE,
        chartControls,
        chartProp,
      );
    }
  };

  // Add only measure field names in select measure dropdown(chart properties is chartProp here)
  let measureFieldId: string[];
  if (chartProp.properties[propKey].chartType === 'scatterPlot') {
    let measureIndexForX = chartProp.properties[propKey].chartAxes.findIndex(
      (value: any) => value.name === 'X Axis',
    );
    let measureIndexForY = chartProp.properties[propKey].chartAxes.findIndex(
      (value: any) => value.name === 'Y Axis',
    );
    let measureFieldNamesForX =
      chartProp.properties[propKey].chartAxes[measureIndexForX]?.fields?.map(
        (field: any) => field.uId,
      ) || [];
    let measureFieldNamesForY =
      chartProp.properties[propKey].chartAxes[measureIndexForY]?.fields?.map(
        (field: any) => field.uId,
      ) || [];
    if (measureFieldNamesForX.length > 0 && measureFieldNamesForY.length > 0) {
      measureFieldId = [...measureFieldNamesForX, ...measureFieldNamesForY];
    } else {
      measureFieldId = [];
    }
  } else {
    let measureIndex = chartProp.properties[propKey].chartAxes.findIndex(
      (value: any) => value.name === 'Measure',
    );
    measureFieldId =
      chartProp.properties[propKey].chartAxes[measureIndex]?.fields?.map(
        (field: any) => field.uId,
      ) || [];
  }

  useEffect(() => {
    let measureAxisInfo = ChartsInfo[chartProp.properties[propKey].chartType].dropZones.find(
      (zone) => zone.name === 'Measure' || zone.name === 'X Axis' || zone.name === 'Y Axis',
    );
    let measureAxis = chartProp.properties[propKey].chartAxes.find(
      (zone: any) => zone.name === 'Measure' || zone.name === 'X Axis' || zone.name === 'Y Axis',
    );
    if (
      checkMinRequiredCards(
        chartProp.properties[propKey],
        chartProp.properties[propKey].chartType,
      ) &&
      measureAxisInfo?.allowedNumbers === 1 &&
      !chartsAreSwitched &&
      measureAxis &&
      measureAxis?.fields[0].uId !== chartControls.properties[propKey].showHide.measureName
    ) {
      resetShowHideValuesToDefault();
    }
    //eslint-disable-next-line
  }, [chartProp.properties[propKey].chartAxes]);

  // Fix 4: Better dependency tracking in useEffect
  useEffect(() => {
    if (descendingChartData.length > 0 && chartControls.properties[propKey].showHide.measureName) {
      const initialSelection = descendingChartData.map((item: any) => item[valueAfterOf]);
      setSelectedMembers(initialSelection);
    }
  }, [descendingChartData, chartControls.properties[propKey].showHide.measureName]);

  const shownull = () => {
    if (descendingChartData.length === 0 || !chartControls.properties[propKey].showHide.measureName)
      return;

    const filteredData = descendingChartData.filter((item: any) =>
      selectedMembers.includes(item[valueAfterOf]),
    );

    // Fix 5: Only update if there's actual data to show
    if (filteredData.length > 0) {
      SortChartData(propKey, filteredData);
    }
  };

  // Fix 7: Initialization on propKey change
  useEffect(() => {
    if (chartControls.properties[propKey].showHide.measureName) {
      handlefun(
        chartControls.properties[propKey].showHide?.operator || equalPatternCollections[0].value,
        true,
      );
    }
  }, [propKey, chartControls.properties[propKey].showHide.measureName]);

  const handleSelectedColumnValue = (event: any) => {
    setAscDescNotify('');
    MeasureValue(propKey, event.target.value);
  };

  // Fix 8: More robust measure field validation
  useEffect(() => {
    if (
      chartControls.properties[propKey].showHide.measureName !== '' &&
      measureFieldId.length !== 0
    ) {
      const find = measureFieldId.some(
        (value) => value === chartControls.properties[propKey].showHide.measureName,
      );
      if (find === false) {
        MeasureValue(propKey, '');
        showHideFilter(propKey, true);
      }
    }
  }, [chartControls.properties[propKey].showHide.measureName, measureFieldId]);

  // Fix 9: Improved filtering function with better error handling
  const handlefun = (prop: string, fromUseEffect = false, showHideValue?: string) => {
    if (!chartControls.properties[propKey].showHide.measureName) {
      return;
    }

    !fromUseEffect &&
      dispatch(
        setShowHideNumberInputValue(propKey, value === '' ? value : Number(value), storeind),
      );
    // Make sure we have valid data before filtering
    if (measureFieldId.length > 0) {
      filterShowHideData(
        prop,
        dispatch,
        serverChartData,
        propKey,
        value,
        chartControls,
        chartProp,
        showHideValue,
      );
    }
  };

  // Fix 10: useEffect to prevent unnecessary renders
  useEffect(() => {
    if (
      !chartControls.properties[propKey].showHide.measureName ||
      descendingChartData.length === 0
    ) {
      return;
    }

    if (isShow) {
      showbutton();
    } else {
      Hidebutton();
    }
  }, [h, selectedMembers.length, isShow, chartControls.properties[propKey].showHide.measureName]);

  const showbutton = () => {
    if (!chartControls.properties[propKey].showHide.measureName) {
      return;
    }

    if (funcnum === 'Numb') {
      showHideFilter(propKey, true);
      if (hidenum === true) {
        setShownum(true);
      }
      setShowNumAction(propKey, true);
      setHidenum(false);
      handlefun(h, false, 'show');
    }
  };

  const Hidebutton = () => {
    if (!chartControls.properties[propKey].showHide.measureName) {
      return;
    }

    if (funcnum === 'Numb') {
      showHideFilter(propKey, false);
      setShowNumAction(propKey, false);
      setShownum(false);
      setHidenum(true);
      handlefun(h, false, 'hide');
    }
  };

  // Fix 11: Data type detection
  const handleclick = (index: any) => {
    if (chartProp.properties[propKey]?.chartAxes[3]?.fields[0]?.dataType) {
      setStoreind(chartProp.properties[propKey].chartAxes[3]?.fields[0]?.dataType);
    } else {
      setStoreind('integer');
    }
  };

  return (
    <>
      {measureFieldId.length > 0 &&
      checkMinRequiredCards(
        chartProp.properties[propKey],
        chartProp.properties[propKey].chartType,
      ) ? (
        <div>
          <div
            className="sort"
            style={{
              marginBottom: '4px',
              paddingTop: '8px',
              marginTop: '15px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Show/Hide
          </div>
          <div style={{ display: 'flex', width: '96%' }}>
            {chartControls.properties[propKey].showHide.measureName ? (
              <OrientationRadioGroup
                orientation={chartControls.properties[propKey].showHide?.isShow ? 'Show' : 'Hide'}
                options={[
                  { name: 'Show', key: 'Show' },
                  { name: 'Hide', key: 'Hide' },
                ]}
                onChange={(key) => {
                  if (key === 'Show') {
                    showbutton();
                  } else {
                    Hidebutton();
                  }
                }}
                style={{ marginLeft: '10px' }}
              />
            ) : (
              <OrientationRadioGroup
                orientation={chartControls.properties[propKey].showHide?.isShow ? 'Show' : 'Hide'}
                options={[
                  { name: 'Show', key: 'Show' },
                  { name: 'Hide', key: 'Hide' },
                ]}
                onChange={() => setAscDescNotify('Firstly Please select column name')}
                style={{ marginLeft: '10px' }}
              />
            )}
          </div>
          <div
            className="sort"
            style={{
              paddingBottom: '0.25rem',
              display: 'flex',
              justifyContent: 'space-between',
              paddingRight: '1.2rem',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            <span>Measure</span>
            <span>
              {chartControls.properties[propKey].showHide.measureName &&
                chartControls.properties[propKey].showHide.numberInput !== '' && (
                  <Tooltip
                    title="Clear Show/Hide"
                    slotProps={{
                      tooltip: {
                        sx: {
                          fontSize: '12px',
                        },
                      },
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="lucide lucide-eraser-icon lucide-eraser"
                      onClick={resetShowHideValuesToDefault}
                    >
                      <path d="M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21" />
                      <path d="m5.082 11.09 8.828 8.828" />
                    </svg>
                  </Tooltip>
                )}
            </span>
          </div>
          <div
            style={{
              width: '91%',
              marginLeft: '6px',
            }}
          >
            <FormControl
              fullWidth
              sx={{
                margin: '0 5px 0 5px',
                '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input': {
                  padding: '10.5px 14px',
                },
              }}
            >
              <Select
                sx={{
                  height: '26px',
                  fontSize: '13px',
                  color: iconColor ? iconColor : '#404040',
                  '&.MuiOutlinedInput-root': {
                    '& fieldset': {
                      border: '1px solid rgb(211, 211, 211)',
                    },
                    '&:hover fieldset': {
                      border: '1px solid #2bb9bb',
                    },
                    '&.Mui-focused fieldset': {
                      border: '1px solid #2bb9bb',
                    },
                    '&.Mui-focused svg': {
                      color: '#2bb9bb',
                    },
                    '& svg': {
                      color: iconColor ? iconColor : '#404040',
                    },
                  },
                }}
                onChange={handleSelectedColumnValue}
                value={chartControls.properties[propKey].showHide.measureName || ''}
                renderValue={(selected) => {
                  const axisName = getNameFromUid(
                    chartProp.properties[propKey].chartAxes,
                    selected,
                  );
                  return axisName;
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      '& .MuiMenuItem-root.Mui-selected': {
                        backgroundColor: 'rgba(43, 185, 187, 0.1)',
                        '&:hover': {
                          backgroundColor: 'rgba(43, 185, 187, 0.2)',
                        },
                      },
                    },
                  },
                }}
              >
                {measureFieldId.map((id, index) => (
                  <MenuItem
                    key={index}
                    value={id}
                    onClick={() => handleclick(index)}
                    sx={{
                      color: 'black',
                      fontSize: '12px',
                      '&:hover': { backgroundColor: 'rgb(238, 238, 238)' },
                    }}
                  >
                    {getNameFromUid(chartProp.properties[propKey].chartAxes, id)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div>
            {ascDescNotify && (
              <p style={{ color: '#ccc', fontStyle: 'italic', fontSize: '10px' }}>
                *{ascDescNotify}*
              </p>
            )}
          </div>

          <div
            style={{
              width: '95%',
              marginLeft: '6px',
              overflow: 'hidden',
            }}
          >
            {chartControls.properties[propKey].showHide.measureName && (
              <Numb
                propKey={propKey}
                h={h}
                setH={setH}
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                value={value}
                setValue={setValue}
                handlefun={handlefun}
                setFuncnum={setFuncnum}
                backgroundColor={backgroundColor}
                iconColor={iconColor}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          <div
            className="sortDisable"
            style={{
              marginBottom: '0rem',
              marginTop: '15px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Show/Hide
          </div>
          <div style={{ display: 'flex', width: '97.5%', marginBottom: '0.5rem' }}>
            <OrientationRadioGroup
              orientation="Show" // default look
              options={[
                { name: 'Show', key: 'Show' },
                { name: 'Hide', key: 'Hide' },
              ]}
              disabled={true}
              onChange={() => {}}
              style={{ marginLeft: '10px' }}
            />
          </div>
          <div
            className="sortDisable"
            style={{ marginBottom: '0rem', color: iconColor ? iconColor : '#404040' }}
          >
            Measure
          </div>
          <div style={{ width: '97.5%' }}>
            <FormControl fullWidth disabled sx={{ margin: '0 10px 0 10px' }}>
              <Select sx={{ width: '95.5%', height: '26px' }}></Select>
            </FormControl>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    chartProp: state.chartProperties,
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateLeftFilterItem: (
      propKey: string,
      binIndex: number,
      itemIndex: number,
      item: any,
      currentChartAxesName: string,
    ) =>
      dispatch(
        editChartPropItem('updateQuery', {
          propKey,
          binIndex,
          itemIndex,
          item,
          currentChartAxesName,
        }),
      ),
    SortChartData: (propKey: string, chartData: string | any) =>
      dispatch(SortChartData(propKey, chartData)),
    showHideFilter: (propKey: string, isShow: boolean) => dispatch(showHideFilter(propKey, isShow)),
    MeasureValue: (propKey: string, value: string | any) => dispatch(MeasureValue(propKey, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowHide);
